import type { TrackingEvent } from '../types/tracking.types';

/**
 * Envia evento para GTM DataLayer
 */
export const sendToGTM = (gtmId: string, event: TrackingEvent): void => {
  if (!gtmId) return;
  
  try {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(event);
  } catch (error) {
    console.error(`❌ GTM: Erro ao enviar evento para ${gtmId}:`, error);
  }
}; 